import React from 'react';
import { FormikTextArea } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const NotesField = () => {
  return (
    <FormField>
      <FormikTextArea id="notes" name="notes" style={{ height: '200px' }} />
    </FormField>
  );
};

export default NotesField;
